import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import TBodyResultsScheduledMessage from 'src/views/management/ScheduledMessagesView/Results/TBodyResultsScheduledMessage';
import helpers from 'src/helpers';

function TBodyResults({
  classes,
  scheduledMessages,
  selectedScheduledMessages,
  userId,
  azAccountName,
  databaseBeingUsed,
  handleSelectOneScheduledMessage,
  handleRowClick,
  handleRefreshPage,
  setCopyValuesToBack,
  query,
}) {
  const [showFullTextInMessages, setShowFullTextInMessages] = useState([]);
  const isShowMoreTextChecked = (id) => showFullTextInMessages.indexOf(id) !== -1;

  const handleClickShowMoreButton = (event, id) => {
    event.stopPropagation();
    setShowFullTextInMessages(
      !isShowMoreTextChecked(id)
        ? [...showFullTextInMessages, id]
        : showFullTextInMessages.filter((item) => item !== id)
    );
  };

  return (
    <TableBody>
      {helpers.transform.toArray(scheduledMessages).map((scheduledMessage) => {
        const { id, messageType } = scheduledMessage || {};
        return (
          <TBodyResultsScheduledMessage
            key={`${messageType}-${id}`}
            userId={userId}
            classes={classes}
            scheduledMessage={scheduledMessage}
            selectedScheduledMessages={selectedScheduledMessages}
            handleSelectOneScheduledMessage={handleSelectOneScheduledMessage}
            handleRowClick={handleRowClick}
            handleClickShowMoreButton={handleClickShowMoreButton}
            isShowMoreTextChecked={isShowMoreTextChecked}
            azAccountName={azAccountName}
            databaseBeingUsed={databaseBeingUsed}
            handleRefreshPage={handleRefreshPage}
            setCopyValuesToBack={setCopyValuesToBack}
            query={query}
          />
        );
      })}
    </TableBody>
  );
}

TBodyResults.propTypes = {
  handleSelectOneScheduledMessage: PropTypes.func.isRequired,
  handleRowClick: PropTypes.func.isRequired,
  setCopyValuesToBack: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  scheduledMessages: PropTypes.array.isRequired,
  selectedScheduledMessages: PropTypes.array.isRequired,
  userId: PropTypes.number.isRequired,
  azAccountName: PropTypes.string.isRequired,
  databaseBeingUsed: PropTypes.string.isRequired,
  handleRefreshPage: PropTypes.func.isRequired,
  query: PropTypes.object,
};

export default TBodyResults;
